import { useQuery } from '@tanstack/react-query'
import { searchHierarchyNew, searchHierarchyNewUsernames } from '@/api/map/member'
import { keys } from '@/api/hooks/shared/keys'

export type SearchHierarchyNewOptions = {
  prefetchOnEmpty?: boolean
}

/** Downline username autocomplete for PL Statement member picker. */
export function useSearchHierarchyNew(
  filter: string,
  enabled: boolean,
  opts?: SearchHierarchyNewOptions,
) {
  const trimmed = filter.trim()
  const query = { filter: trimmed, page: 1 as const }
  const shouldFetch = opts?.prefetchOnEmpty ? true : trimmed.length >= 1

  return useQuery({
    queryKey: keys.searchHierarchyNew(query),
    queryFn: async () => {
      const rows = await searchHierarchyNew({ filter: trimmed, page: 1 })
      return searchHierarchyNewUsernames(rows)
    },
    enabled: enabled && shouldFetch,
    placeholderData: (previous) => previous,
    staleTime: 10_000,
    gcTime: 60_000,
    retry: false,
  })
}
